import MotivationElementNodeType from '../MotivationElementNodeType';
import {MOTIVATION_STAKEHOLDER} from '../../metamodel/Concept';

export default class StakeholderNodeType extends MotivationElementNodeType {
	static get typeName() {
		return MOTIVATION_STAKEHOLDER;
	}
}
